import React from 'react'
import PartnersFeatured from '../Shared/Partners/PartnersFeatured'
import urls from '@/utils/urls/urls'
import AnimationWrapper from '../AnimationWrapper/AnimationWrapper'
// import cl from '@/utils/console/cl'

const BrandFeaturedContainer = async () => {
    const res = await fetch(urls?.brand)
    const data = await res.json()   
    const brands = await Array.isArray(data?.data) ? data?.data : [];
    // console.log("brands", brands)

    return (
        <div className="service-area sa-bg pt-80 pb-10">
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-6">
                        <AnimationWrapper animation="fade-left">
                            <div className="site-heading mb-0">
                                <span className="site-title-tagline">
                                    <i className="far fa-solar-panel" /> Partners
                            </span>
                            <h2 className="site-title text-white">
                                Let's check our <span>Partners</span>
                            </h2>
                            <p className="text-white mb-4">
                                At Tex Excellence Limited, our mission is to assist brands, designers, and manufacturers in creating cutting-edge fabric technologies that significantly enhance the final products.
                            </p>
                            {/* <Link href="service" className="theme-btn">
                      All Services
                      <i className="fas fa-arrow-right" />
                    </Link> */}
                            </div>
                        </AnimationWrapper>
                    </div>
                    <div className="col-lg-6">
                        <AnimationWrapper animation="fade-right">
                            <PartnersFeatured brands={brands} />
                        </AnimationWrapper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrandFeaturedContainer
